import React, { memo } from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import type { HandlerProps } from '../../common/types.tsx';
import Resizer from './main.tsx';
import { ResizeHandle as ResizeHandleNew } from './ResizeHandle.tsx';
import { ResizeHandleOld } from './styled.tsx';

const ResizeHandle = componentWithFG(
	'jfp-magma-hydration-resizer',
	ResizeHandleNew,
	ResizeHandleOld,
);

export default memo<HandlerProps>((props: HandlerProps) => (
	<ErrorBoundary
		id="async.issue.view.resizer"
		packageName="async.issue.view.resizer"
		render={() => <ResizeHandle />}
	>
		<Resizer {...props} />
	</ErrorBoundary>
));
